import * as R from 'ramda'
import { of } from 'rxjs'
import { delayWhen, distinctUntilChanged, filter, ignoreElements, tap } from 'rxjs/operators'
import { ofType } from 'redux-observable'
import { LOCATION_CHANGE } from 'connected-react-router'
import facebookPixel from 'tracking/facebookPixel'
import { awaitForSaleFetched } from 'store/epics/helpers'
import { isCatalogOrUniversePageAction } from 'domain/router'
import {
  getCurrentResourceSubUniverseId,
  getCurrentResourceUniverseId,
  getOperationCode,
  getOperationId,
  getIsSaleFetched
} from 'store/selectors'
import { disableFacebookTracking } from '../disable'

export const mapStateToFPEvent = (state) => {
  const universeId = getCurrentResourceSubUniverseId(state) || getCurrentResourceUniverseId(state)

  return {
    content_ids: [universeId],
    content_type: 'product group',
    operation_code: getOperationCode(state),
    operation_ID: getOperationId(state)
  }
}

const viewContentCatalogEpic = (actions$, state$) => actions$.pipe(
  disableFacebookTracking(actions$),
  ofType(LOCATION_CHANGE),
  distinctUntilChanged(R.eqBy(R.path(['payload', 'location', 'pathname']))),
  filter(isCatalogOrUniversePageAction),
  delayWhen(() => getIsSaleFetched(state$.value)
    ? of({})
    : awaitForSaleFetched(actions$, state$)
  ),
  tap(() => {
    facebookPixel.track('ViewContent', mapStateToFPEvent(state$.value))
  }),
  ignoreElements()
)

export default viewContentCatalogEpic
